import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { PlandayService } from '@fi-app/external-platform-integration/planday/planday.service';
import { FiSpinnerService } from '@fi-shared/fi-spinner/fi-spinner.service';
import { AppTextService } from '@fi-shared/app-text';
import { ProgressType } from '@fi-shared/fi-signal-r/fi-signal-enums';

@Component({
    selector: 'planday-import-users',
    templateUrl: './planday-import-users.component.html',
    styleUrls: ['./planday-import-users.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'planday-import-users' },
    standalone: false,
})
export class PlandayImportUsersComponent {
    constructor(
        private plandayService: PlandayService,
        private fiSpinnerService: FiSpinnerService,
        private appTextService: AppTextService,
    ) {}

    onTestImportUsersClick() {
        const isTestMode = true;
        const promise = this.plandayService.importPlandayUsers(isTestMode);
        this.showProgress(promise, isTestMode);
    }

    onImportUsersClick() {
        const isTestMode = false;
        const promise = this.plandayService.importPlandayUsers(isTestMode);
        this.showProgress(promise, isTestMode);
    }

    private showProgress(promise: Promise<any>, isTestMode: boolean) {
        let headerTextId: string;
        if (isTestMode) {
            headerTextId = 'pk.testing_import';
        } else {
            headerTextId = 'pk.user_import';
        }
        this.fiSpinnerService.trackPromise(promise, {
            headerText: this.appTextService.get(headerTextId),
            signalRProgressType: ProgressType.PlandayImportUsers,
        });
    }
}
